import { createContext, useState, useContext, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

const RebusSessionContext = createContext();

export function RebusSessionProvider({ children, sessionId }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setLoading(false);
      return;
    }

    // Real-time listener
    const sessionRef = doc(db, 'rebusSessions', sessionId);
    const unsubscribe = onSnapshot(
      sessionRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setSession({ id: snapshot.id, ...snapshot.data() });
          setError(null);
        } else {
          setError('Fann ikkje Mikkelchase-økta');
        }
        setLoading(false);
      },
      (err) => {
        console.error('Rebus session listener error:', err);
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [sessionId]);

  return (
    <RebusSessionContext.Provider value={{ session, loading, error }}>
      {children}
    </RebusSessionContext.Provider>
  );
}

export function useRebusSession() {
  const context = useContext(RebusSessionContext);
  if (!context) {
    throw new Error('useRebusSession must be used within RebusSessionProvider');
  }
  return context;
}
